
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/rEditor/rootComps/selectionBox/parentContainerBox/parentContainerBox.scss.css.virtualfile';
        module.exports = {"container":"_container_zpaax_7","frame":"_frame_zpaax_10","label":"_label_zpaax_19"};